// extracted by mini-css-extract-plugin
export default {"shared":"\"../../shared.module.css\"","md":"768px","questionPageQuestionsContainer":"QuestionPage_questionPageQuestionsContainer__-lFBO"};